import Vue from "vue";
import vuetify from "./plugins/vuetify";
import App from "./App.vue";
import router from "./config/router";
import "@/plugins/highcharts";
import "./config/registerServiceWorker";
import store from "./store";
import "@fortawesome/fontawesome-free/css/all.css";

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
